import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "restore-account" }
const _hoisted_2 = { class: "restore-container" }
const _hoisted_3 = { class: "verification-input" }
const _hoisted_4 = { class: "form-actions" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import type { FormInstance, FormRules } from 'element-plus';
import axios from 'axios';
import { config } from '@/config/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'RestoreAccountView',
  setup(__props) {

const API_BASE_URL = config.apiBaseUrl;
const router = useRouter();
const formRef = ref<FormInstance>();
const restoring = ref(false);
const countdown = ref(0);

const form = ref({
  email: '',
  verificationCode: ''
});

const rules: FormRules = {
  email: [
    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
  ],
  verificationCode: [
    { required: true, message: '请输入验证码', trigger: 'blur' },
    { len: 6, message: '验证码长度应为6位', trigger: 'blur' }
  ]
};

const sendVerificationCode = async () => {
  try {
    // 验证邮箱
    await formRef.value?.validateField('email');
    
    const response = await axios.post(
      `${API_BASE_URL}/api/user/send-restore-code?email=${form.value.email}`
    );
    
    if (response.data.success) {
      ElMessage.success('验证码已发送到您的邮箱');
      // 开始倒计时
      countdown.value = 60;
      const timer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    }
  } catch (error: any) {
    if (error.response?.data?.message) {
      ElMessage.error(error.response.data.message);
    } else if (error.message) {
      ElMessage.error(error.message);
    } else {
      ElMessage.error('发送验证码失败');
    }
  }
};

const handleRestore = async () => {
  if (!formRef.value) return;
  
  try {
    await formRef.value.validate();
    
    restoring.value = true;
    const response = await axios.post(
      `${API_BASE_URL}/api/user/restore-account?email=${form.value.email}&verificationCode=${form.value.verificationCode}`
    );
    
    if (response.data.success) {
      ElMessage.success('账号已成功恢复，请重新登录');
      router.push('/login');
    }
  } catch (error: any) {
    if (error.response?.data?.message) {
      ElMessage.error(error.response.data.message);
    } else if (error.message) {
      ElMessage.error(error.message);
    } else {
      ElMessage.error('恢复账号失败');
    }
  } finally {
    restoring.value = false;
  }
};

const goBack = () => {
  router.push('/login');
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", null, "账号恢复", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "description" }, "如果您的账号已被注销，可以在这里恢复您的账号。", -1)),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "邮箱地址",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
                placeholder: "请输入注销账号的邮箱地址",
                type: "email"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "验证码",
            prop: "verificationCode"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_input, {
                  modelValue: form.value.verificationCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.verificationCode) = $event)),
                  placeholder: "请输入验证码",
                  maxlength: "6"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      disabled: countdown.value > 0,
                      onClick: sendVerificationCode
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(countdown.value > 0 ? `${countdown.value}s后重试` : '获取验证码'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, { onClick: goBack }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("返回登录")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: restoring.value,
              onClick: handleRestore
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" 恢复账号 ")
              ])),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})